































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: { Button }
})
export default class DuplicateAccountFoundMessage extends Vue {
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();

  onLoginClick () {
    this.userStore.logout();
  }
  get supportPhoneNumber () {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }
  get hrefSupportPhoneNumber () {
    return `tel:${this.supportPhoneNumber}`;
  }
}
